// Public privacy policy page. Must be viewable without authentication (Plaid reviewers
// and consumers read it before linking).
//
// Rendered from the canonical markdown at docs/privacy-policy.md so the on-site page and
// the generated PDF share one source and cannot drift. The markdown is a trusted,
// repo-controlled file (not user input), so rendering its HTML is safe.

import { marked } from "marked";

import privacyMarkdown from "../../../docs/privacy-policy.md?raw";

const html = marked.parse(privacyMarkdown, { async: false }) as string;

export function Privacy() {
  return (
    <article
      className="policy mx-auto max-w-3xl text-sm leading-relaxed text-muted-foreground"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
